module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h2fa"
  }, [_c('a', {
    attrs: {
      "id": "page_6"
    }
  }), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('b', [_vm._v("Acknowledgements")])]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("I couldn’t have written word the first without the love and support of the Williamses, Gantts, and Shareefs. Endless thanks to Tricia, Renae, Abby, and Lori for refusing to let me give up when the road got rocky—and to Charlotte, for the web series brainstorm. To my agent, Brettne Bloom, I bow down to your dedication and uncanny literary instincts. You helped me breathe such big, juicy life into Jenna’s story! And to my editor/homegirl Cherise Fisher—there’d be zero book if it weren’t for your passion, patience, and therapy sessions (#allhats). I’m here because of you. Period. ReShonda, Victoria and the Brown Girls team, bless you for making my dream a reality. Dawn, you’re a P.R. goddess. And Lina Lina Bobina, my darling little girl, you are my greatest inspiration. You’re not allowed to read this until you’re twenty-five.")]), _vm._v(" "), _c('p', {
    staticClass: "bodytext"
  }, [_vm._v("S.—thank you for lending a major character your middle name. And for everything, really. You live in every line.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30bd1f37","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Acknowledgements.vue
// module id = 69
// module chunks = 0